export const GROUP_COLUMN = {
    STORE: 'Store',
    PHYSICAL: 'Physical',
};